// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".airport-code[data-v-67a6adba]  .el-form-item__content {\n  width: 12em;\n}", ""]);
// Exports
module.exports = exports;
